import script from "./parent-container.ce.vue?vue&type=script&setup=true&lang=ts"
export * from "./parent-container.ce.vue?vue&type=script&setup=true&lang=ts"

import _style_0 from "./parent-container.ce.vue?vue&type=style&index=0&id=2cf4e539&inline&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['styles',[_style_0]],['__scopeId',"data-v-2cf4e539"]])

export default __exports__